export * from './lib/user.service.module';

export { AccredibleUserApiService } from './lib/user.service';
